import React from 'react';
import { List, Tooltip } from 'antd';
import { useDispatch } from 'react-redux';
import { setSelectedInfo } from '../../store/actions';
import { getInfoTypeIcon } from '../../utils';
import { getActions } from './utils';
import { formatDate } from '../../utils';

const Item = ({ item, selected }) => {
  const dispatch = useDispatch();

  const datePub = formatDate(item.datePub);
  const dateEnd = formatDate(item.dateEnd);

  const handleClick = () => dispatch(setSelectedInfo(item));

  return (
    <List.Item
      key={item.id}
      onClick={handleClick}
      style={{
        backgroundColor: selected ? '#eeeeee' : 'white',
        cursor: 'pointer',
        padding: '10px 20px 5px 20px',
      }}
      actions={getActions(item)}
    >
      <List.Item.Meta
        avatar={
          item.type ? (
            <Tooltip title={item.type.name}>
              <div style={{ marginTop: 6 }}>
                {getInfoTypeIcon(item.type.id, 42)}
              </div>
            </Tooltip>
          ) : (
            <div />
          )
        }
        title={item.title}
        description={
          <div style={{ color: '#009fdc' }}>{item.serviceCompany}</div>
        }
      />
      <div style={{ fontSize: 16, fontWeight: 500, paddingLeft: 60 }}>
        {datePub} - {dateEnd}
      </div>
    </List.Item>
  );
};

export default Item;
